import $ from "jquery";

("use strict");

const CMS_UTIL = {
    SELECTOR_BREADCRUMB_CHANNEL_ID: '#auth-breadcrumb-channel-ids',
    CLIENT_PROSPECT: '0'
}

export function initCmsUtil() {
    // Init cms Util
    if (!window.cmsUtil) window.cmsUtil = {};

    // global variable to know if we are in prospect context
    if ((!typeof userSegmentNames === "undefined")
        && (userSegmentNames.indexOf(CMS_UTIL.CLIENT_PROSPECT) != -1)) {
        window.cmsUtil.isProspect = true;
    } else {
        window.cmsUtil.isProspect = false;
    }

    // global variable to know id of current channels breadcrumb
    window.cmsUtil.currentChannelBreadcrumb = $(CMS_UTIL.SELECTOR_BREADCRUMB_CHANNEL_ID).val();


    // Init cms Text Constants
    if (!window.cmsConstantsLabel) window.cmsConstantsLabel = {};

    window.cmsConstantsLabel.DESKTOP_FOLD_THE_MENU = "Replier la navigation principale";
    window.cmsConstantsLabel.DESKTOP_UNFOLD_THE_MENU = "Déplier la navigation principale";
    window.cmsConstantsLabel.MOBILE_OPEN_THE_MENU = "Ouvrir le menu";
    window.cmsConstantsLabel.MOBILE_CLOSE_THE_MENU = "Fermer le menu";
}


// WEBPACK FOOTER //
// ./src/js/cms/util/initCmsUtil.js